import gql from "graphql-tag";

export const REPORT_DETAIL_QUERY = gql`
  query ReportDetail($reportId: ID!) {
    report(id: $reportId) {
      id
      ownerCompany
      dataValidation
      secret
      name
      report_number
      created_at
      order_confirmation
      shipping_date
      order_date
      customer_order_number
      step
      customer
      manufacturer
      production_plant
      updated_at
      signatureUrl
      recordedBy
      doneBySupervisor
      work_order_nr
      availablePdfLayouts
      dataProgress
      dataValidation
      attachments {
        uuid
        url
        fileName
        mimeType
        description
        characteristic {
          id
          shortcut
          translations {
            de
            en
            zh
          }
        }
      }

      sheets {
        id
        dataValidation
        material_certificate
        heat_nr
        charge
        orderQuantity
        dataProgress
        dataValidation
        template {
          id
          name
          productTemplateCharacteristics {
            id
            shortcut
          }
        }
        attachments {
          uuid
          url
          fileName
          mimeType
          description
          mc
          characteristic {
            id
            shortcut
            translations {
              de
              en
              zh
            }
          }
        }
        info {
          woodNr
          insertionDirection
          woodMoisture
          woodDensity
          roomTemperature
          roomMoisture
        }
        rtor_mw
        rtor_k1
        rtor_k2
        ftor_k1
        my_k1
        fax_k1
        fhead_k1
        ftens_k1
        tor_rat_1
        tor_rat_2
        tor_rat_3
        product {
          id
          technicalDrawing
          description
          articleNumber
          customer
          screwType
          head
          screwDiameter
          screwLength
          recessType
          surfaceColor
          threadType
          customerArticleNumber
          customerProductDescription
          drawing1Url
          drawing2Url
          drawing3Url
          productGroup {
            id
            name
          }
          properties {
            stringValue {
              id
              propertyType
              value
            }
            singleValue {
              id
              propertyType
              name
            }
            multpileValues {
              propertyType
              id
              values {
                id
                propertyType
                name
              }
            }
          }
        }
        characteristicGroups {
          characteristics {
            id
            shortcut
            dataType
            isCritical
            translations {
              de
              en
              zh
            }
            measurements {
              value
            }
            unit {
              name
            }
            unitTranslations {
              de
              en
              zh
            }
            minDiff
            maxDiff
            value1
            value2
            order
          }
        }
      }
    }
  }
`;
